import React, { useMemo } from "react";
import { useMeet } from "util/useMeet";
import get from "lodash/get";
import PouchInput from "components/PouchInput";
import { getYouTubeEmbedSrc } from "util/liveStream";
import map from "lodash/map";
import sortBy from "lodash/sortBy";

const LiveStream = () => {
  const meet = useMeet();

  const sortedPlatforms = useMemo(() => {
    return sortBy(meet.platforms, "name");
  }, [meet.platforms]);

  return (
    <div className="entry-config">
      <div className="registration-title">Live Stream</div>
      {map(sortedPlatforms, (platform) => {
        return (
          <div className="entry-row" key={platform._id}>
            <label style={{ width: 120 }}>
              Platform {platform.name} <br /> YouTube Link:
            </label>
            <div style={{ flexGrow: 1 }}>
              <PouchInput
                type="text"
                meetId={meet._id}
                documentId={platform._id}
                name="liveStreamLink"
                value={get(platform, "liveStreamLink")}
              />
              {platform.liveStreamLink &&
                !getYouTubeEmbedSrc(platform.liveStreamLink) && (
                  <div>Error: Invalid link</div>
                )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default LiveStream;
